import { render, staticRenderFns } from "./PwdConfiguration.vue?vue&type=template&id=125bdbb8&scoped=true&"
import script from "./PwdConfiguration.vue?vue&type=script&lang=js&"
export * from "./PwdConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./PwdConfiguration.vue?vue&type=style&index=0&id=125bdbb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125bdbb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VContainer,VSnackbar})
